import { useDispatch } from 'react-redux';

import { HTTPMethod } from '@perpay-web/constants/httpMethods';
import { getData, useDataModule } from '@perpay-web/data-module/useDataModule';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/useReduxDataModuleHookConnection';
import { refreshAccessToken } from '@perpay-web/fintech/actions/authentication';
import {
    submitOrderForUnderwriting,
    submitOrderForUnderwritingError,
    submitOrderForUnderwritingReset,
    submitOrderForUnderwritingSuccess,
} from '@perpay-web/fintech/actions/entities/submitOrderForUnderwriting';
import { CHECKOUT_DECISION_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { authenticatedJsonFetch } from '@perpay-web/fintech/utils/requestHandlers';
import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

export const getDecision = (state) => getData(state).decision;

const initialValue = {
    decision: null,
};

const useSubmitOrderForUnderwritingDataModule = () => {
    const dispatch = useDispatch();
    const dataModule = useDataModule(
        (uuid) =>
            authenticatedJsonFetch(
                CHECKOUT_DECISION_ENDPOINT.replace(':uuid', uuid),
                {},
                HTTPMethod.post,
            ),
        { initialValue },
    );

    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: submitOrderForUnderwriting,
        error: submitOrderForUnderwritingError,
        success: submitOrderForUnderwritingSuccess,
        reset: submitOrderForUnderwritingReset,
    });

    useActionObservableCallback(
        hookAction$,
        submitOrderForUnderwritingSuccess().type,
        () => {
            dispatch(refreshAccessToken());
        },
    );

    return dataModule;
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = useSubmitOrderForUnderwritingDataModule();
        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [
    UseSubmitOrderForUnderwritingDataModuleProvider,
    useSubmitOrderForUnderwritingContext,
] = createContextProvider(providerFactory);
